import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// SHOWCASE MODE: when set to "true" in /app/frontend/.env, all auth gates are
// bypassed (no login required, all routes public). Flip back to "false" or
// remove the var to re-enable normal auth.
const AUTH_BYPASS = process.env.REACT_APP_AUTH_BYPASS === 'true';

function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF6EC]">
      <div className="flex items-center gap-3 text-[#3A4A44]">
        <span className="w-2 h-2 rounded-full bg-[#4A7C5E] animate-pulse" />
        <span className="font-display text-base tracking-tight">Checking your session…</span>
      </div>
    </div>
  );
}

/** Guards a route — redirects to /login if no user, or /login if admin-only and user isn't admin. */
export default function ProtectedRoute({ children, adminOnly = false, allowUnsubscribed = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  // Showcase mode: skip auth entirely (including admin-only routes).
  if (AUTH_BYPASS) return children;
  if (loading) return <FullPageLoader />;
  if (!user) {
    // Preserve the intended destination so login can return them here.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  if (!allowUnsubscribed && user.role !== 'admin' && user.subscription_active === false) {
    return <Navigate to={`/pricing?email=${encodeURIComponent(user.email || '')}`} replace />;
  }
  return children;
}
